var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-grow"},[(!_vm.isLoading)?_c('div',[_c('PDFBlueprintsEdit',{ref:"PDFBlueprintsEdit",staticClass:"w-full",attrs:{"is-for-onboarding":true,"template-i-d-param":_vm.blueprintID}})],1):_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }